import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const WelcomeBackWrapperStackStyles: StyleExtend<Theme> = {
  mt: 9.5,
  gap: 4.5,
  p: (theme) => theme.spacing(3, 6, 6),
  border: (theme) => `1px solid ${theme.palette.customColors.lightGray}`,
  boxShadow: (theme) => theme.customStyling.shadow.quoteDetailsCard,
};
